export enum API_FIELDS_CONTACT {
  // MODULE API
  ID = 'id',
  // Contact/Personal Information
  firstName = 'First_Name',
  lastName = 'Last_Name',
  preferredName = 'Preferred_Name',
  gender = 'Gender',
  dateOfBirth = 'Date_of_Birth',
  cityOfBirth = 'birth_city',
  occupation = 'Occupation',
  age = 'Age',
  // Citizenship information
  countryOfBirth = 'birth_country',
  residence = 'permanent_residence',
  citizenship = 'citizenship',
  // Communication:
  email = 'Email',
  mobile = 'Mobile',
  homePhone = 'home_number',
  workPhone = 'Work_Phone',
  phone = 'Phone',
  // Address information:
  addressLine1 = 'street',
  addressLine2 = 'Address_Line_2',
  city = 'city',
  postalCode = 'postal_code',
  country = 'country',
  state = 'State',
  // Emergency contact information:
  emergencyContactName = 'Emergency_Contact',
  emergencyContactRelation = 'EC_Relation_to_applicant_father_mother_friend_etc',
  emergencyContactPhoneNumber = 'EC_Phone_Number',
  // Student Family
  relationship = 'Relationship',
  parentStatus = 'Life_Status',
  isLegalGuardian = 'Is_a_legal_guardian',
  contactClassification = 'Contact_Classification',
  studentFamilyLookup = 'Account_Name',
}

export enum CONTACT_CLASSIFICATION {
  guardian = 'Parent/Guardian',
  familyMember = 'Student Family Member',
  friendsAndRelatives = 'Friends / Relatives in the U.S.',
  student = 'Student',
}
